export const convertCardExpiryToString = (month, year) => {
    const parts = [month, year % 2000].map((part) => (part < 10 ? `0${part}` : part.toString()));
    return parts.join('/');
};
//# sourceMappingURL=convert-card-expiry-to-string.js.map